import flatstr from 'flatstr';
export function flatString(str) {
    return flatstr(str);
}
export function jsonFlatStringify(data, replacer, space) {
    return flatString(JSON.stringify(data, replacer, space));
}
//# sourceMappingURL=flat-string.js.map